import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { EmailEffects } from './effects/email.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([EmailEffects])],
})
export class WebAngularSharedUtilEmailApiModule {}
